import MuiAvatar from "@mui/material/Avatar";
import Box from "@mui/material/Box/Box";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import styled from "styled-components";

export const Content = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
`;

export const PlayersContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const OptionWithDividerWrapper = styled(Box)`
  display: flex;
  width: 100%;
  gap: 10px;
  flex-direction: column;
`;

export const TeamsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
  transform: translateY(-28px);
`;

export const OptionWithIconWrapper = styled(Box)`
  display: flex;
`;

export const PlayerWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Title = styled(Typography)`
  color: #000;
  font-family: "Outfit-SemiBold";
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const UserViewChipWrapper = styled(Box)`
  padding-right: 20px;
`;

export const Teams = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 20px;
`;

export const Team = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TeamHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TeamMembers = styled(Typography)`
  color: #000;
  text-align: right;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const TeamDescription = styled(Typography)`
  color: var(--colours-grey-500, #718096);
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const TeamTitle = styled(Typography)`
  color: #000;
  font-family: "Outfit-SemiBold";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`;

export const PlayerInfoWrapper = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;

export const Avatar = styled(MuiAvatar)`
  width: 28px;
  height: 28px;
  background-color: var(--colours-grey-400, #a0aec0);
  color: var(--colours-primary-rkbt-black, #1d1d1d);
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const PlayerName = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const OrganizerLabel = styled(Typography)`
  color: #000;
  font-family: "NotoSans-Medium";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

export const DesktopShareDialog = styled(DialogContent)`
  width: 340px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 8px;
  border: 0.5px solid #d9d9d9;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
`;

export const ShareActions = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DesktopShareTitle = styled(Typography)`
  color: #263238;
  text-align: center;
  font-family: "NotoSans-Medium";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;
